<template>
</template>

<script>
import {getQueryObject} from '../../../static/fun.js';
import {fromIndex } from '../../api/api';

export default {
  methods: {
    //获取登录用户信息
	getLoginUser(){
		//获取id
		fromIndex({}).then((res) => {
			this.loading = false;
			let resData = res.data;
			if (resData.code != 200) {
					this.$router.push({ path: '/login' });
			}else{
                this.$router.push({ path: '/indexPage' });
			}
		});
	},
  },
  mounted() {
	//判断单点登录传过来的token
	var tokenUrl=getQueryObject("token");

    console.log(tokenUrl)
	if(tokenUrl!=false){
        this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {})
        sessionStorage.setItem("token",tokenUrl)

        this.getLoginUser();

	}
  }
};
</script>


// WEBPACK FOOTER //
// SingleSignOn.vue?0617f8c6